/// <reference path="../../ng-services/chat.service.ts"/>

import { Meeting } from '../../models/chat';
import { ChatService } from '../../ng-services/chat.service';
import { MeetingsStore } from '../../ng-services/meetings.store';
import { PinnedMeetingProviderService } from '../../ng-services/pinned-meeting-provider.service';

(function () {
    class ChatComponent {
        static $inject = ['$scope', 'ChatService', 'PinnedMeetingProviderService', 'MeetingsStore'];

        public pinnedMeetingId?: number | null;

        // this is a single conversation wrapped in array
        // this way when active conversation is changed, the component will get destroyed and recreated
        // TODO REFACTOR: We should not do that, instead we can react in $onChanges in the child component
        public conversation?: Meeting[];

        public isMeetingListOpen: boolean = true;

        constructor(
            private $scope: angular.IScope,
            private chatService: ChatService,
            private pinnedMeetingProviderService: PinnedMeetingProviderService,
            private meetingsStore: MeetingsStore
        ) {
            this.pinnedMeetingProviderService.getPinnedMeetingId().then((id) => {
                this.pinnedMeetingId = id;
            });

            this.chatService.getActiveMeeting$().subscribe((active) => {
                this.conversation = active ? [active] : [];
            });

            this.meetingsStore.isMeetingListOpen$.subscribe((v) =>
                this.$scope.$evalAsync(() => {
                    this.isMeetingListOpen = v;
                })
            );
        }
    }

    angular.module('tradersyard').component('tyChat', {
        // language=HTML
        template: `
<div class="chat">
    <div class="sidebar-section__header">
        <h2 class="sidebar-section__title">Chat</h2>
    </div>
    <ty-meeting-list pinned-meeting-id="$ctrl.pinnedMeetingId" ng-show="$ctrl.isMeetingListOpen"/>
    <div class="chat_upload_drag_and_drop" ty-chat-upload-drag-and-drop>
        <ty-chat-conversation  ng-repeat="conversation in $ctrl.conversation" conversation="conversation"/>
    </div>
</div>
    `,
        controller: ChatComponent,
    });
})();
